import { Provider } from 'react-redux';

import { setupStore } from './store/appStore';
import Body from './components/Body';
import ThemeProvider from './components/ThemeProvider';
import { BrowserRouter as Router } from 'react-router-dom';

const store = setupStore();
function App() {
  return (
    <Provider store={store}>
      <ThemeProvider>
        <Router>
          <Body />
        </Router>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
